import AuthService from "../../Components/auth/AuthService";
const Auth = new AuthService()

export const fetchVehicleReport = async (payload) => {
    const res = await Auth.fetch("/report/vehicle-maintenance", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return res;
};

export const fetchDriverLicenseChecks = async (payload) => {
    const res = await Auth.fetch("/report/driver-license-checks", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return res;
};

export const fetchFuelReport = async (payload) => {
    const res = await Auth.fetch("/report/fuel-records", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return res;
};

export const fetchServiceReport = async (payload) => {
    const res = await Auth.fetch("/report/service-records", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return res;
};


